import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Importing custom components
import { IconButton } from '../../core/icon-button';
import { Tooltip } from '../../core/tooltip';
// Importing hooks
import { useShallow } from 'zustand/react/shallow';
import { useTranslation } from 'react-i18next';
// Importing icons
import FullscreenIcon from '@mui/icons-material/FullscreenRounded';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
// Importing store
import { usePlayerStore } from '../../../store/player.store';
// Importing 3rd party dependencies
import { useEffect } from 'react';
import screenfull from 'screenfull';
// ----------------------------------------------------------------------
export const FullscreenButton = () => {
    // Adding hooks
    const { t } = useTranslation();
    // Adding data handler
    const { fullscreen, setFullscreen } = usePlayerStore(useShallow((state) => ({
        fullscreen: state.fullscreen,
        setFullscreen: state.setFullscreen,
    })));
    // Adding callback to handle button clicks
    const handleFullscreen = () => {
        screenfull.isEnabled && !fullscreen
            ? screenfull.request(document.querySelector('#cba-player'))
            : screenfull.exit();
    };
    // Adding callback to handle all fullscreen changes
    // This is needed to capture ESC key press
    const toggleFullScreenOnChange = () => {
        setFullscreen(!fullscreen);
    };
    // Adding event listeners
    useEffect(() => {
        document.addEventListener('fullscreenchange', toggleFullScreenOnChange);
        document.addEventListener('webkitfullscreenchange', toggleFullScreenOnChange);
        document.addEventListener('mozfullscreenchange', toggleFullScreenOnChange);
        document.addEventListener('MSFullscreenChange', toggleFullScreenOnChange);
    }, []);
    return (_jsx(Tooltip, { title: t('player:controls:fullscreen:title'), children: _jsxs(IconButton, { "aria-label": "fullscreen", onClick: handleFullscreen, children: [!fullscreen && _jsx(FullscreenIcon, {}), fullscreen && _jsx(FullscreenExitIcon, {})] }) }));
};
